import { EStores, ILoginState } from "../reducers/auth.reducers";
import { Dispatch } from "redux";
import { apiAction } from "../middlewares/api.middleware.helper";
import { endpoints } from "constant";
import Cookie from "universal-cookie";
import { apiError } from "./api.actions";
import {
  AUTH_LOGIN,
  AUTH_SET_COUNTRY,
  AUTH_GET_USER,
  AUTH_LOGOUT,
  AUTH_UPDATE_LOCATION,
  AUTH_SWITCH_STORE,
  AUTH_VERIFY_BOUND_STORE,
} from "store/store.types";
import { EMethods, IState } from "store/store.interface";

const cookie = new Cookie();

export const getAndSetUserInfo = (access_token: string) =>
  apiAction({
    label: AUTH_GET_USER,
    method: EMethods.GET,
    url: endpoints.USER_INFO,
    isAbsoluteUrl: false,
    data: {},
    withToken: true,
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
    onSuccess: ({ data }) =>
      setLoginToState({ ...data } as ILoginState),
  });

export const setLocation = (path: string) => ({
  type: AUTH_UPDATE_LOCATION,
  payload: path,
});

const verifyBoundStore = (storeId: EStores, onBound?: () => void) =>
  apiAction({
    label: AUTH_VERIFY_BOUND_STORE,
    method: EMethods.GET,
    url: endpoints.USER_INFO,
    isAbsoluteUrl: false,
    data: {},
    withToken: true,
    withStoreId: false,
    onSuccess: (response) => (dispatch: Dispatch) => {
      const boundStoreId = response?.data?.boundStoreId;
      if (boundStoreId !== storeId) {
        dispatch(apiError("Bound store cookie was not established", AUTH_VERIFY_BOUND_STORE));
        return;
      }
      if (onBound) {
        onBound();
      }
    },
  });

export const switchStore = (storeId: EStores, onBound?: () => void) =>
  apiAction({
    label: AUTH_SWITCH_STORE,
    method: EMethods.POST,
    url: endpoints.SWITCH_STORE,
    isAbsoluteUrl: false,
    data: { storeId },
    withToken: true,
    withStoreId: false,
    onSuccess: () => (boundDispatch: Dispatch<any>) => {
      boundDispatch(verifyBoundStore(storeId, onBound));
    },
  });

export const setStoreId =
  (storeId: EStores) => (dispatch: Dispatch, getState: () => IState) => {
    const { selectOptions = {} } = getState().config;
    const { countries } = selectOptions;
    let timeZone = "Asia/Dubai";
    if (countries && countries.length > 0) {
      timeZone =
        (
          countries.find((country) => country.value === storeId) || {
            timeZone: "Asia/Dubai",
          }
        ).timeZone || "Asia/Dubai";
    }
    cookie.set("pe_storeid", storeId);
    cookie.set("pe_tz", timeZone);
    dispatch({ type: AUTH_SET_COUNTRY, payload: { storeId, timeZone } });
  };

export const signout = () => (dispatch: Dispatch) => {
  cookie.remove("acc_token")
  cookie.remove("pe_storeid");
  cookie.remove("pe_tz");
  dispatch({ type: AUTH_LOGOUT });
};

const setLoginToState = (result: ILoginState) => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_LOGIN,
    payload: result,
  });
};

